import {
  LoadCurrentSurvey,
  LoadCurrentSurveyCompleted,
  LoadCurrentSurveyFailed,
  LoadSurveys,
  LoadSurveysCompleted,
  LoadSurveysFailed,
} from './survey-load.action';
import { SelectSurvey, SelectSurveyCompleted, SelectSurveyFailed } from './survey-select.action';
import {
  ResetCurrentSurvey,
  ResetCurrentSurveyCompleted,
  ResetCurrentSurveyFailed,
  UpdateCurrentSurvey,
  UpdateCurrentSurveyCompleted,
  UpdateCurrentSurveyFailed,
  UpdateSurvey,
  UpdateSurveyCompleted,
  UpdateSurveyFailed,
  UpdateSurveyProgress,
  UpdateSurveyProgressCompleted,
  UpdateSurveyProgressFailed,
} from './survey-update.action';

export { SurveyActionType } from './survey-action-type.enum';

export {
  LoadSurveys,
  LoadSurveysCompleted,
  LoadSurveysFailed,
  LoadCurrentSurvey,
  LoadCurrentSurveyCompleted,
  LoadCurrentSurveyFailed,
} from './survey-load.action';
export {
  ResetCurrentSurvey,
  ResetCurrentSurveyCompleted,
  ResetCurrentSurveyFailed,
  UpdateSurvey,
  UpdateSurveyCompleted,
  UpdateSurveyFailed,
  UpdateSurveyProgress,
  UpdateSurveyProgressCompleted,
  UpdateSurveyProgressFailed,
  UpdateCurrentSurvey,
  UpdateCurrentSurveyCompleted,
  UpdateCurrentSurveyFailed,
} from './survey-update.action';
export { SelectSurvey, SelectSurveyCompleted, SelectSurveyFailed } from './survey-select.action';

export type SurveyActions =

  LoadSurveys |
  LoadSurveysCompleted |
  LoadSurveysFailed |
  LoadCurrentSurvey |
  LoadCurrentSurveyCompleted |
  LoadCurrentSurveyFailed |

  ResetCurrentSurvey |
  ResetCurrentSurveyCompleted |
  ResetCurrentSurveyFailed |
  UpdateSurvey |
  UpdateSurveyCompleted |
  UpdateSurveyFailed |
  UpdateSurveyProgress |
  UpdateSurveyProgressCompleted |
  UpdateSurveyProgressFailed |
  UpdateCurrentSurvey |
  UpdateCurrentSurveyCompleted |
  UpdateCurrentSurveyFailed |

  SelectSurvey |
  SelectSurveyCompleted |
  SelectSurveyFailed;
